import { jsx as _jsx } from "react/jsx-runtime";
import debug from 'debug';
import { useRecoilRedux } from '@/hooks/useRecoilRedux';
const log = debug('moveo:iframe:controller');
const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
const RecoilDevTools = () => {
    useRecoilRedux();
    return null;
};
export const SafeRecoilDevTools = () => {
    // Due to an error with recoil in Safari and Firefox,
    // we need to disable the dev tools
    // See https://github.com/facebookexperimental/Recoil/issues/1994
    // and https://github.com/facebookexperimental/Recoil/pull/1943
    if (!isChrome) {
        log('Browser is not chrome, disable recoil+redux');
        return null;
    }
    return _jsx(RecoilDevTools, {});
};
